export function updateDataTableHeaderPosition(
  headerGap: number,
  table: HTMLTableElement | null,
  header: HTMLTableSectionElement | null,
  fixedHeader: HTMLTableSectionElement | null
) {
  if (!table || !header || !fixedHeader) return;

  const headerBoundingRect = header.getBoundingClientRect();

  const tableBoundingRect = table.getBoundingClientRect();
  const headerBottomScroll = tableBoundingRect.top - headerGap;

  const tablePosition =
    table.clientHeight +
    tableBoundingRect.top -
    //window.innerHeight +
    headerGap -
    50; // TODO fix this hardcoded value;

  if (tablePosition > 0) {
    if (-headerBottomScroll < 0) {
      fixedHeader.classList.remove("scrolled-header");
    } else {
      fixedHeader.classList.add("scrolled-header");
    }
    fixedHeader.style.transform = `translateY(${Math.max(
      -headerBottomScroll,
      0
    )}px)`;
  }
}
